import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BookingModel from 'models/booking';
import { surpassedStartTimeCannotCancel, packageCannotCancel, monthlyCannotCancel } from 'lib/common/messages';

const propTypes = {
  booking: PropTypes.instanceOf(BookingModel).isRequired,
  buttonStyle: PropTypes.string.isRequired,
  addMessageAndScrollToTop: PropTypes.func.isRequired,
};

const defaultProps = {

};

class Cancel extends Component {
  constructor(props) {
    super(props);

    this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line global-require
    require('smoothscroll-polyfill').polyfill();
  }

  isCancellable() {
    const { booking } = this.props;

    // We handle the 'partner' cancellation reason messaging on the main
    // cancellation page, so we can let those clicks through.
    return !booking.uncancellableReason() || booking.uncancellableReason() === 'partner';
  }

  handleCancelButtonClick() {
    const { booking, addMessageAndScrollToTop } = this.props;
    const uncancellableReason = booking.uncancellableReason();

    switch (uncancellableReason) {
      case 'surpassed_start_time':
        addMessageAndScrollToTop(surpassedStartTimeCannotCancel);
        break;
      case 'package':
        addMessageAndScrollToTop(packageCannotCancel);
        break;
      case 'monthly':
        addMessageAndScrollToTop(monthlyCannotCancel);
        break;
      default:
        break;
    }
  }

  renderButtonContent() {
    let buttonText;

    if (this.props.buttonStyle === 'inline') {
      buttonText = 'Cancel';
    } else {
      buttonText = 'Cancel Booking';
    }

    return (
      <Fragment>
        <span className="iconified-font iconified-trash margin-right-5" />
        <span>{buttonText}</span>
      </Fragment>
    );
  }

  render() {
    let buttonClasses;

    if (this.props.buttonStyle === 'inline') {
      buttonClasses = 'text-align-center display-block padding-vertical-15 text-size-12 text-color-hover-white background-color-hover-red text-color-red clickable';
    } else {
      buttonClasses = 'btn btn-deco-doc btn-block btn-alternate btn-red clickable';
    }

    if (!this.isCancellable()) {
      return (
        <div onClick={this.handleCancelButtonClick} className={buttonClasses}>
          { this.renderButtonContent() }
        </div>
      );
    }

    return (
      <Link
        to={{ pathname: `/ticket/cancel/${this.props.booking.id}` }}
        className={buttonClasses}
      >
        { this.renderButtonContent() }
      </Link>
    );
  }
}

Cancel.propTypes = propTypes;
Cancel.defaultProps = defaultProps;

export default Cancel;
